var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.064C22.5 6.23 17.799 1.5 12 1.5S1.5 6.23 1.5 12.064c0 5.273 3.84 9.643 8.86 10.436v-7.382H7.692v-3.054h2.666V9.737c0-2.648 1.568-4.11 3.966-4.11 1.15 0 2.35.206 2.35.206v2.6h-1.323c-1.305 0-1.711.814-1.711 1.65v1.981h2.912l-.466 3.054H13.64V22.5c5.02-.793 8.859-5.163 8.859-10.436Z"
  })));
};
export default SvgFacebook;